import { render } from "./ClosureManagement.vue?vue&type=template&id=4f07a83f&scoped=true"
import script from "./ClosureManagement.vue?vue&type=script&lang=js"
export * from "./ClosureManagement.vue?vue&type=script&lang=js"

import "./ClosureManagement.vue?vue&type=style&index=0&id=4f07a83f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f07a83f"]])

export default __exports__